import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef, useContext } from 'react';
import { Icon } from '../../icon/index.js';
import { FCTheme } from '../../../theming/FCTheme.js';
import { InputWrapper, IconWrapper, StyledInput } from './style.js';
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var theme = useContext(FCTheme);

  var id = props.id,
      inError = props.inError,
      inWarning = props.inWarning,
      icon = props.icon,
      readOnly = props.readOnly,
      autoComplete = props.autoComplete,
      rest = __rest(props, ["id", "inError", "inWarning", "icon", "readOnly", "autoComplete"]);

  return /*#__PURE__*/React.createElement(InputWrapper, null, icon && /*#__PURE__*/React.createElement(IconWrapper, {
    "aria-hidden": true,
    theme: theme.theme,
    inError: inError,
    inWarning: inWarning
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  })), /*#__PURE__*/React.createElement(StyledInput, __assign({
    id: id,
    ref: ref,
    icon: icon,
    inError: inError,
    inWarning: inWarning,
    theme: theme.theme,
    readOnly: readOnly,
    autoComplete: autoComplete
  }, rest)));
});
Input.displayName = 'Input';
export default Input;
export { Input };